import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType,
  ICustomTable, LoadingPanelService, LocalService, Page,DATE_WITH_HOUR_FORMAT } from 'lib-base';
import { SolicitudActividadesService } from '../../../../services/database/pqrsd/solicitud-actividades.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetMisPqrsd } from '../../../../shared/interfaces/database/pqrsd';
import { TableLazyLoadEvent } from 'primeng/table';
import { SolicitudHistorialActividadComponent } from '../../mis-pqrsd/solicitudes-historial/solicitud-historial-actividad/solicitud-historial-actividad.component';

@Component({
  selector: 'app-pqrsd-gestionar-actividades-pendientes',
  standalone: true,
  imports: [CustomTableComponent, SolicitudHistorialActividadComponent],
  templateUrl: './gestionar-actividades-pendientes.component.html',
  styleUrl: './gestionar-actividades-pendientes.component.scss'
})
export class GestionarActividadesPendientesComponent implements OnInit {
  @Input() tramEstados: string[] = [];
  @Input() tramActividadEstados: string[] = [];
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  constructor(private readonly _sa: SolicitudActividadesService, private readonly _t: TranslateService, public ls: LocalService, private readonly _router: Router,
      private readonly _lps: LoadingPanelService
    ) {
    }

    ngOnInit(): void {
      this.translate().then(() => this.configurarTabla());
    }

    private async translate(): Promise<void> {
      this.trans = await firstValueFrom(forkJoin({
        radicado: this._t.get('common.radicado'),
        tipo: this._t.get('common.tipo'),
        observaciones: this._t.get('common.observaciones'),
        estado: this._t.get('common.estado'),
        fechaActualización: this._t.get('common.fechaActualización'),
        fechaSolicitud: this._t.get('common.fechaSolicitud'),
        usuarioAsignado: this._t.get('common.usuarioAsignado')
      }));
    }

  configurarTabla(): void {
    this.customTable = {
      caption:{
        globalFilter:{
          placeholder: this.trans.usuarioAsignado + '...'
        }
      },
      header:{},
      columns: [
        {
          field: 'expand',
          header: '',
          class:'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'radicado',
          header: this.trans.radicado,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tipoDescripcion',
          header: this.trans.tipo,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'observacion',
          header: this.trans.observaciones,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'solicitudEstado',
          header: this.trans.estado,
          sort: true,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.ESTADO_TAG
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualización,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
        {
          field: 'fechaSolicitud',
          header: this.trans.fechaSolicitud,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
      ],
      settings: {
        table: {
          rows: 8,
          lazy: true
        }
      }
    } as ICustomTable;
  }

  getAllMisPqrsd(event?: TableLazyLoadEvent){
    this._lps.show(true);
    this._sa.getAllMisPqrsd(this.tramEstados, this.tramActividadEstados, event).subscribe({
      next: (data: Page<IGetMisPqrsd>) => {
        this._lps.hide();
        this.customTableComponent.data = data.content;
        this.customTableComponent.totalRecords = data.totalElements;
      }
    });
  }

  lazyloadRecords(event: TableLazyLoadEvent) {
    this.getAllMisPqrsd(event);
  }
}
